import { GLOBAL_TYPE } from "../constants";

const globalReducer = (state = {
   loginExpired: false
}, action) => {
   switch (action.type) {
      case GLOBAL_TYPE.LOGIN_EXPIRED:
         return {
            ...state,
            loginExpired: true
         }
      default:
         return state;
   }
};

export default globalReducer